import React from "react";

const TimelineSingleStep = ({ data, active, approved, lastItem }) => {
	// mounting the class
	const stepClasses = [
		"timeline-single-step",
		approved ? "approved" : "",
		lastItem ? "timeline-single-step--half-item last-item" : ""
	].join(" ");
	const circleClasses = ["timeline-single-step__circle", active || approved ? "active" : ""].join(
		" "
	);

	return (
		<div className={stepClasses}>
			<div className="timeline-single-step__item">
				<span className="timeline-single-step__label height50">{data.label}</span>
				<div className="height50">
					<div className={circleClasses}>{approved && <i className="icon-check" />}</div>
					{data.description && (
						<div className="timeline-single-step__description">{data.description}</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default TimelineSingleStep;
